import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';
import { useProductEntity } from 'src/utils/Hooks/reduxSelectors';

const AtlasUnitsSoldMarketShareProductSplineChart = () => {
  const { productEntity } = useProductEntity();
  return (
    <AtlasV2DorisSplineChart
      queryKey="UnitsSoldProductMarketShareSplineChart"
      title="Market Share of Units Sold"
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="unitsSold"
      showMarketShare={true}
      marketShareRequestBuilder={(params) => {
        return {
          ...params,
          stacklineSkus: [],
          categoryIds: productEntity?.categoryIds
        };
      }}
    />
  );
};

export default AtlasUnitsSoldMarketShareProductSplineChart;
